import React, { useEffect, useState } from 'react';
import { getAllInsights, pauseCampaign, resumeCampaign } from '../utils/api';
import { PageTitle, Card, Table, Btn, Loading, Empty, statusBadge, Badge } from '../components/UI';

export default function Campaigns() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [preset, setPreset] = useState('today');
  const [acting, setActing] = useState(null);

  const load = (p) => {
    setLoading(true);
    getAllInsights(p)
      .then(r => setCampaigns(r.data?.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(preset); }, [preset]);

  const handlePause = async (id) => {
    setActing(id);
    await pauseCampaign(id).catch(console.error);
    await load(preset);
    setActing(null);
  };

  const handleResume = async (id) => {
    setActing(id);
    await resumeCampaign(id).catch(console.error);
    await load(preset);
    setActing(null);
  };

  const roasColor = (roas) => {
    if (roas >= 3) return '#55efc4';
    if (roas >= 1.5) return '#ffd200';
    return '#ff6584';
  };

  const presets = ['today', 'yesterday', 'last_7d', 'last_30d', 'this_month'];

  return (
    <div>
      <PageTitle title="📋 Campaigns" sub="সব campaigns একনজরে" />

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {presets.map(p => (
          <Btn key={p} color={preset === p ? '#6c63ff' : '#1e1e2e'} onClick={() => setPreset(p)}>
            {p}
          </Btn>
        ))}
      </div>

      <Card>
        {loading ? <Loading /> : campaigns.length === 0 ? <Empty /> : (
          <Table
            headers={['Campaign', 'Spend', 'ROAS', 'CTR', 'CPC', 'Clicks', 'Actions']}
            rows={campaigns.map((c, i) => {
              const roas = parseFloat(c.purchase_roas?.[0]?.value || 0);
              const isPaused = c.status === 'PAUSED';
              return (
                <tr key={i}>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', maxWidth: 220 }}>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{c.campaign_name}</div>
                    <div style={{ fontSize: 11, color: '#6b6b80', marginTop: 3 }}>{c.campaign_id}</div>
                  </td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 14 }}>৳{parseFloat(c.spend || 0).toFixed(0)}</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e' }}>
                    <span style={{ color: roasColor(roas), fontWeight: 700 }}>{roas.toFixed(2)}</span>
                  </td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 14, color: '#6b6b80' }}>{parseFloat(c.ctr || 0).toFixed(2)}%</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 14 }}>৳{parseFloat(c.cpc || 0).toFixed(2)}</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 14 }}>{parseInt(c.clicks || 0).toLocaleString()}</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e' }}>
                    {isPaused
                      ? <Btn color="#43e97b" disabled={acting === c.campaign_id} onClick={() => handleResume(c.campaign_id)}>▶ Resume</Btn>
                      : <Btn color="#ff6584" disabled={acting === c.campaign_id} onClick={() => handlePause(c.campaign_id)}>⏸ Pause</Btn>
                    }
                  </td>
                </tr>
              );
            })}
          />
        )}
      </Card>
    </div>
  );
}
